/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DashboardTemplates
 * @hideconstructor
 * @classdesc API class that is used to manage DashboardTemplates
 * (including the corrsponding view) across API calls
 */
define([
	'./api/impl/DashboardTemplatesImpl'
], function(DashboardTemplatesImpl){

	class DashboardTemplates {

		constructor({ features }) {
			this._dashboardApi = features.API;
			this._api = new DashboardTemplatesImpl({
				feature: this,
				logger: this._dashboardApi.getGlassSvc('.Logger'),
				getContentSvc: this._dashboardApi.getGlassSvc('.Content'),
				featureChecker: this._dashboardApi.getGlassCoreSvc('.FeatureChecker')
			});
		}

		getAPI() {
			return this._api.getAPI();
		}

		destroy() {
			this._api = null;
		}
	}
	return DashboardTemplates;
});